export enum TransferInventoryWorkflowStatus {
  Pending = 14,
  Submitted = 15,
  Voided = 16,
}

export const TRANSFER_INVENTORY_WORKFLOW_STATUS_OPTIONS: ReadonlyArray<{
  id: TransferInventoryWorkflowStatus;
  name: string;
  color: string;
}> = [
  { id: TransferInventoryWorkflowStatus.Pending, name: "Pending", color: "warning" },
  { id: TransferInventoryWorkflowStatus.Submitted, name: "Submitted", color: "success" },
  { id: TransferInventoryWorkflowStatus.Voided, name: "Voided", color: "medium" },
];
